import qrcode from 'qrcode-generator';

class QRModal {
  constructor() {
    this.modal = document.getElementById('qr-modal');
    this.closeBtn = document.querySelector('.qr-modal-close');
    this.qrContainer = document.getElementById('qr-code-container');
    this.companyNameEl = document.querySelector('.qr-modal-company-name');
    this.companyImageEl = document.querySelector('.qr-modal-company-image');
    this.qrButtons = document.querySelectorAll('.qr-btn, .qr-btn-table, .qr-btn-gmo, .qr-btn-banner');
    
    this.init();
  }
  
  init() {
    if (!this.modal || !this.qrButtons.length) return;
    
    this.qrButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleButtonClick(e));
    });
    
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closeModal());
    }
    
    window.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });
  }
  
  handleButtonClick(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const url = button.getAttribute('data-url');

    if (!url) return;

    // GTM用にdataLayerにイベントをpush
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'qr_button_click',
        'button_class': button.className,
        'button_url': url
      });
    }

    // 業者情報を取得
    const companyInfo = this.getCompanyInfo(url);
    this.showQRCode(url, companyInfo);
  }
  
  getCompanyInfo(url) {
    // URLから業者を判定
    if (url.includes('gaikaex_gmo')) {
      return {
        name: 'GMO外貨',
        image: '/assets/fxranking04.jpg'
      };
    } else if (url.includes('sbi_fxtrade')) {
      return {
        name: 'SBI FXトレード',
        image: '/assets/sbi_fxtrade_300x250.png'
      };
    } else if (url.includes('gmo_click')) {
      return {
        name: 'GMOクリック証券',
        image: '/assets/fxranking02.png'
      };
    } else if (url.includes('minna_fx')) {
      return {
        name: 'みんなのFX',
        image: '/assets/fximg03.png'
      };
    } else if (url.includes('matsui_fx')) {
      return {
        name: 'MATSUI FX',
        image: '/assets/fximg06.png'
      };
    } else if (url.includes('hirose')) {
      return {
        name: 'ヒロセ通商',
        image: '/assets/fximg07.png'
      };
    } else if (url.includes('light_fx')) {
      return {
        name: 'LIGHT FX',
        image: '/assets/LightFX.jpg'
      };
    } else if (url.includes('gaitame_online')) {
      return {
        name: '外為オンライン',
        image: '/assets/fximg09.png'
      };
    } else {
      return {
        name: 'FX業者',
        image: ''
      };
    }
  }
  
  getFullUrl(url) {
    // 相対パスの場合はホストを追加
    if (url.startsWith('/')) {
      return window.location.origin + url;
    }
    return url;
  }
  
  showQRCode(url, companyInfo) {
    // Clear previous QR code
    this.qrContainer.innerHTML = '';
    
    // Set company name
    if (this.companyNameEl) {
      this.companyNameEl.textContent = companyInfo.name;
    }
    
    // Set company image
    if (this.companyImageEl && companyInfo.image) {
      this.companyImageEl.src = companyInfo.image;
      this.companyImageEl.alt = companyInfo.name;
    }
    
    // フルパスのURLを生成
    const fullUrl = this.getFullUrl(url);
    
    // Generate QR code using qrcode-generator
    const qr = qrcode(0, 'M');
    qr.addData(fullUrl);
    qr.make();
    
    // Create image element
    const img = document.createElement('img');
    img.src = qr.createDataURL(4);
    img.style.width = '200px';
    img.style.height = '200px';
    
    this.qrContainer.appendChild(img);
    
    // Show modal
    this.modal.style.display = 'flex';
  }
  
  closeModal() {
    this.modal.style.display = 'none';
  }
}

// Initialize when DOM is ready
const initQRModal = () => {
  new QRModal();
};

// Support for Turbolinks
document.addEventListener('DOMContentLoaded', initQRModal);
document.addEventListener('turbolinks:load', initQRModal);

export default QRModal;